export function toggleFavouriteMatchInStorage(matchUniqueId, match, idAggregata) {
	const favouritesLocalStorage = JSON.parse(localStorage.getItem('x_fav_mtchs') || '{}');
    if (favouritesLocalStorage[matchUniqueId] !== undefined) {
    	delete favouritesLocalStorage[matchUniqueId];
    } else {
		favouritesLocalStorage[matchUniqueId] = {...match, idAggregata};
	}
    localStorage.setItem('x_fav_mtchs',JSON.stringify(favouritesLocalStorage));

}
